export default __webpack_public_path__ + "static/media/scales.9ac0ac46.png";